import React, { useEffect } from "react";
import Logo from "./../logo/Logo";
import "./dialog.scss";

function Dialog(props) {
  useEffect(() => {
    document.body.style.overflow = props.open ? "hidden" : "";
  }, [props.open]);

  if (!props.open) return null;

  return (
    <div
      className="dialog"
      role="dialog"
      aria-labelledby="dialog-header"
      aria-modal="true"
    >
      {props.logo && <Logo />}
      <div className="dialog__container">
        <div>
          <h2 className="dialog__header text-uppercase" id="dialog-header">
            {props.header}
          </h2>
          <p className="dialog__description">{props.description}</p>
          <div className="dialog__cta">{props.children}</div>
        </div>
      </div>
    </div>
  );
}

export default Dialog;
